import { TCrudPartnerLink, TPartnerLink } from 'clickNgo/entities/partner/models'

export const mapPartnerLinksFromCrud = (links: string): TPartnerLink[] => {
  if (links) {
    const parsedObject: TCrudPartnerLink[] = JSON.parse(links)
    return parsedObject.map((link, index) => ({
      id: index,
      value: link.value,
      private: link.private,
    }))
  }
  return []
}
